
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 34 34"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd"}},[_c('path',{attrs:{"d":"M29.467 8.612l-7.359-7.358A.86.86 0 0021.497 1H5.144a.865.865 0 00-.865.865v30.27c0 .478.388.865.865.865h23.712a.865.865 0 00.865-.865V9.223c0-.23-.092-.45-.254-.611zm-8.08-5.634l6.326 6.325h-6.326V2.978zm6.604 28.292H6.009V2.73h13.648v7.438c0 .478.387.865.865.865h7.469V31.27z"}}),_c('path',{attrs:{"d":"M9.75 10.6h6.262a.432.432 0 000-.864H9.75a.432.432 0 000 .864zm-.432 3.468c0 .239.193.432.432.432h14.5a.432.432 0 000-.864H9.75a.431.431 0 00-.432.432zm14.932 3.469H9.75a.431.431 0 100 .864h14.5a.432.432 0 000-.864zm0 3.901H9.75a.431.431 0 100 .864h14.5a.432.432 0 000-.864zm0 3.902H9.75a.431.431 0 100 .864h14.5a.432.432 0 000-.864z"}})])])
          )
        }
      }
    